import Vue from "vue";

const error = {
  install(Vue) {
    Vue.prototype.$getError = function (e) {
      if (e.response) {
        if (e.response.data) {
          const code = parseInt(e.response.data.code);
          switch (code) {
            case 401:
              Vue.prototype.$auth.logout();
              window.location.reload(false);
              return false;
            case 403:
              this.$toast.error('شما دسترسی لازم به این صفحه را ندارید');
            case 404:
              this.$toast.error('مشکلی پیش آمده است لطفا مجددا وارد شوید');
              return false;
            case 500:
              this.$toast.error('مشکلی پیش آمده است');
              return false;
            default:
              if (Array.isArray(e.response.data.message))
                e.response.data.message.forEach(item => this.$toast.error(item));
              if (typeof e.response.data.message == "object")
                Object.keys(e.response.data.message).forEach(item => this.$toast.error(item))
          }
        }
      } else if (typeof e == 'string') {
        this.$toast.error(e);
        console.error(e);
      }
    }
  }
};
Vue.use(error);

export default error;
